import { type ThemeOptions } from '@mui/material';

import { colors } from './colors';

export const palette: ThemeOptions['palette'] = {
  blue: {
    main: colors[0],
  },
  red: {
    main: colors[1],
  },
  orange: {
    main: colors[2],
  },
  green: {
    main: colors[3],
  },
  yellow: {
    main: colors[4],
  },
  black: {
    main: colors[5],
  },
  white: {
    main: colors[6],
  },
  blue100: {
    main: colors[7],
  },
  blue400: {
    main: colors[8],
  },
  blue500: {
    main: colors[9],
  },
  blue800: {
    main: colors[10],
  },
  blue900: {
    main: colors[11],
  },
  gray100: {
    main: colors[12],
  },
  gray200: {
    main: colors[13],
  },
  gray300: {
    main: colors[14],
  },
  gray500: {
    main: colors[15],
  },
  gray800: {
    main: colors[16],
  },
  yellow100: {
    main: colors[17],
  },
  green100: {
    main: colors[18],
  },
  green400: {
    main: colors[19],
  },
  green900: {
    main: colors[20],
  },
  orange100: {
    main: colors[21],
  },
  red100: {
    main: colors[22],
  },
  shadyblue100: {
    main: colors[23],
  },
  shadyblue900: {
    main: colors[24],
  },
  red300: {
    main: colors[25],
  },
  red500: {
    main: colors[26],
  },
  red900: {
    main: colors[27],
  },
  green500: {
    main: colors[28],
  },
  orange500: {
    main: colors[29],
  },
  skyBlue100: {
    main: colors[30],
  },
};
